import { render, staticRenderFns } from "./Uploader.vue?vue&type=template&id=c249a33a&scoped=true&lang=pug"
import script from "./Uploader.vue?vue&type=script&lang=js"
export * from "./Uploader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c249a33a",
  null
  
)

export default component.exports